import React from 'react';
import { Typography, Button } from '@mui/material';
import s from './BookingDetailsPage.module.scss';
import CircularProgress from "@mui/material/CircularProgress";
import { format } from 'date-fns';

const ConfirmationStep = ({ bookingResponse, product, selectedSession, bookingData, navigate }) => {
    if (!bookingResponse) {
        return (
            <div className={s.confirmation}>
                <CircularProgress size={60} />
                <Typography variant="h6" className="mt-6">予約を処理中です...</Typography>
            </div>
        );
    }

    const order = bookingResponse;

    return (
        <div className={s.confirmation}>
            <div className={s.confirmationCard}>
                <Typography variant="h3" className={s.confirmation__title}>
                    予約完了しました！ 🎉
                </Typography>

                <div className={s.confirmationSummary}>
                    <Typography variant="h5" className={s.summaryTitle}>
                        予約番号 #{order.orderNumber}
                    </Typography>
                    <Typography variant="subtitle1" className={s.statusBadge} style={{
                        color: order.status === 'CONFIRMED' ? '#16a34a' : '#d97706',
                        fontWeight: 'bold'
                    }}>
                        ステータス: {order.status.replace('_', ' ')}
                    </Typography>

                    <div className={s.summaryGrid}>
                        <div className={s.summaryRow}>
                            <span className={s.summaryLabel}>お客様のお名前</span>
                            <span className={s.summaryValue}>
                {order.customer.firstName} {order.customer.lastName}
              </span>
                        </div>
                        <div className={s.summaryRow}>
                            <span className={s.summaryLabel}>メールアドレス</span>
                            <span className={s.summaryValue}>{order.customer.email}</span>
                        </div>
                    </div>

                    <div className={s.summaryGrid}>
                        <div className={s.summaryRow}>
                            <span className={s.summaryLabel}>ツアー</span>
                            <span className={s.summaryValue}>{product.name}</span>
                        </div>
                        <div className={s.summaryRow}>
                            <span className={s.summaryLabel}>日付</span>
                            <span className={s.summaryValue}>
                {format(new Date(selectedSession.startTimeLocal), 'yyyy年M月d日 (EEE)')}
              </span>
                        </div>
                        <div className={s.summaryRow}>
                            <span className={s.summaryLabel}>参加人数</span>
                            <span className={s.summaryValue}>{bookingData.totalParticipants}名</span>
                        </div>
                        <div className={s.summaryRow}>
                            <span className={s.summaryLabel}>合計金額</span>
                            <span className={s.summaryValue} style={{fontWeight: 'bold', color: '#16a34a'}}>
                ${order.totalAmount?.toFixed(2) || '0.00'}
              </span>
                        </div>
                    </div>

                    {order.voucherUrl && (
                        <div className={s.voucherSection}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                href={order.voucherUrl}
                                target="_blank"
                                className={s.voucherButton}
                            >
                                バウチャーPDFをダウンロード
                            </Button>
                        </div>
                    )}

                    <Typography variant="body1" className={s.confirmation__text}>
                        確認メールが <strong>{order.customer.email}</strong> に送信されました。
                    </Typography>
                </div>

                <Button
                    variant="outlined"
                    size="large"
                    onClick={() => navigate('/')}
                    className="mt-8"
                >
                    別のツアーを予約する
                </Button>
            </div>
        </div>
    );
};

export default ConfirmationStep;